import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate, Navigate} from "react-router-dom";
import Home from './pages/Home/Home';
import Createpost from './pages/Createpost/Createpost';
import Login from './pages/Login/Login';
import Logout from './pages/Logout/Logout';
import Navbar from './components/Navbar/Navbar';
import EmailRegistration from './components/EmailRegistration';
import SignUp from './components/SignUp';
import MasterEditer from './components/MasterEditer/MasterEditer';
import Gantt from './pages/gantt/gantt';
import Edit from './pages/Edit/Edit';
import CreateMaster from './pages/Edit/tab03/tab03';
import EditMaster from './pages/Edit/Edit';
import InquiryForm from './pages/InquiryForm/InquiryForm';
import UtilityList from './pages/UtilityList/UtilityList';
import TreeViewEdit from "./pages/treeViewEdit/treeViewEdit";
import SelectProject from "./pages/ProjectSelect/SelectProject";
// import InviteMembers from "./pages/InviteMembers/InviteMembers"
import InviteMembers from "./pages/ProjectManager/tabs/InviteMembers";
import ProjectManager from "./pages/ProjectManager/ProjectManager"
import MasterList from "./pages/MasterList/MasterList"
import JoinProject from "./pages/JoinProject/JoinProject"

import ProtectedRoute from "./components/ProtectedRoute";
import { TreeViewProvider } from "./context/treeViewContext";
import { EditStateProvider } from "./context/EditStateContext";
import { useEditState } from "./context/EditStateContext";


// ⭐ Router配下で現在のパスを取得できるようにするコンポーネント
import { useMatch } from "react-router-dom";

// ★ 指定の画面ではヘッダーが切り替わる
function BackHeader({ title = '編集画面' }) {
  const navigate = useNavigate();
  const { isEditing } = useEditState();
  return (
    <header className="back-header">
      <button 
      className="back-button" 
      onClick={() => navigate(-1)}
      disabled={isEditing}
      style={{ opacity: isEditing ? 0.5 : 1 }}      >
        ← 戻る
      </button>
      <h1 className="back-title">{title}</h1>
    </header>
  );
}


// ---------- AppWrapper ----------
function AppWrapper() {
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const authStatus = localStorage.getItem("isAuth") === "true";
    setIsAuth(authStatus);
  }, []);

  return (
    <TreeViewProvider>
      <EditStateProvider>
        <Router>
          <AppContent isAuth={isAuth} setIsAuth={setIsAuth} />
        </Router>
      </EditStateProvider>
    </TreeViewProvider>
  );
}

// ---------- AppContent ----------
function AppContent({ isAuth, setIsAuth }) {
  const location = useLocation();

  // /EditMaster/:masterID のときだけ true                    ←このコードで、app.jsの画面を切り替える
  const isEditMasterPage = /^\/EditMaster\/[^/]+$/.test(location.pathname);

  return (
    <>
      {!isEditMasterPage && <Navbar isAuth={isAuth} />}
      {isEditMasterPage && <BackHeader title="" />}

      {/* <Routes>
        <Route path="/" element={<UtilityList />} />
        <Route path="/UtilityList" element={
            <ProtectedRoute>
              <UtilityList setIsAuth={setIsAuth}/>
            </ProtectedRoute>}/>
        <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />
        <Route path="/EmailRegistration" element={<EmailRegistration />} />
        <Route path="/SignUp" element={<SignUp />} />
        <Route path="/logout" element={<Logout setIsAuth={setIsAuth} />} />
        <Route path="/masterediter" element={<MasterEditer setIsAuth={setIsAuth} />} />
        <Route path="/gantt" element={<Gantt setIsAuth={setIsAuth} />} />
        <Route path="/Edit" element={<Edit setIsAuth={setIsAuth} />} />
        <Route path="/CreateMaster" element={<CreateMaster setIsAuth={setIsAuth} />} />
        <Route path="/treeViewEdit" element={<TreeViewEdit setIsAuth={setIsAuth} />} />
        <Route path="/EditMaster/:masterID" element={<EditMaster setIsAuth={setIsAuth} />} />
        <Route path="/InquiryForm" element={<InquiryForm setIsAuth={setIsAuth} />} />
        <Route path="/UtilityList" element={<UtilityList setIsAuth={setIsAuth} />} />
      </Routes> */}


  <Routes>
  {/* ✅ ログイン不要のルート */}
    <Route path="/login" element={<Login setIsAuth={setIsAuth} />} />
    <Route path="/login/join" element={<Navigate to="/login" replace />} />
    <Route path="/join" element={<Login setIsAuth={setIsAuth} />} /> {/* ←これを追加 */}
    <Route path="/EmailRegistration" element={<EmailRegistration />} />
    <Route path="/SignUp" element={<SignUp />} />

  {/* ✅ 以下すべてログイン必須 */}
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <UtilityList setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    
    <Route
      path="/UtilityList"
      element={
        <ProtectedRoute>
          <UtilityList setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/logout"
      element={
        <ProtectedRoute>
          <Logout setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/masterediter"
      element={
        <ProtectedRoute>
          <MasterEditer setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/gantt"
      element={
        <ProtectedRoute>
          <Gantt setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/Edit"
      element={
        <ProtectedRoute>
          <Edit setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/CreateMaster"
      element={
        <ProtectedRoute>
          <CreateMaster setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/treeViewEdit"
      element={
        <ProtectedRoute>
          <TreeViewEdit setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/EditMaster/:masterID"
      element={
        <ProtectedRoute>
          <EditMaster setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    <Route
      path="/InquiryForm"
      element={
        <ProtectedRoute>
          <InquiryForm setIsAuth={setIsAuth} />
        </ProtectedRoute>
      }
    />
    
    <Route
      path="/selectproject"
      element={
        <ProtectedRoute>
          <SelectProject setIsAuth={setIsAuth} />
        </ProtectedRoute>
        }
    />

    <Route
      path="/projectmanager"
      element={
        <ProtectedRoute>
          <ProjectManager setIsAuth={setIsAuth} />
        </ProtectedRoute>
        }
    />
    <Route
      path="/invite-members"
      element={
        <InviteMembers>
          <ProjectManager setIsAuth={setIsAuth} />
        </InviteMembers>
        }
    />
    <Route
      path="/master-list"
      element={
        <MasterList>
          <ProjectManager setIsAuth={setIsAuth} />
        </MasterList>
        }
    />
    <Route
      path="/join-project"
      element={
        <JoinProject>
          <ProjectManager setIsAuth={setIsAuth} />
        </JoinProject>
        }
    />

</Routes>

    </>
  );
}

export default AppWrapper;
